import { Form, Select } from 'antd';

import type { DefaultOptionType } from 'antd/es/select';

const { Item } = Form;

interface Props {
  name: string;
  label: string;
  options: DefaultOptionType[];
  onChange?: () => void;
}

export const OperationWarehouseSelect = ({
  name,
  label,
  options,
  onChange,
}: Props) => (
  <Item
    name={name}
    label={label}
    required
    wrapperCol={{ span: 7 }}
    rules={[{ required: true, message: 'Пожалуйста, укажите склад' }]}
  >
    <Select
      showSearch
      optionFilterProp="label"
      options={options}
      placeholder="Выберите склад"
      onChange={onChange}
    />
  </Item>
);
